import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { Icon, Tooltip } from "antd";
import { connect } from "react-redux";

import Mention from "../Mention";
import CalendarPicker from "../CalendarPicker";
import UserService from "../../services/user";

import "./SearchBar.scss";
import DefaultUserImage from "../../assets/img/avatar_user_black.png";
import { ReactComponent as ListFilterSvg } from "../../assets/icon/ic_list_filter_24dp.svg";
import { ReactComponent as CheckSvg } from "../../assets/icon/ic_check_24dp.svg";
import { ReactComponent as SearchSvg } from "../../assets/icon/ic_search_24dp.svg";
import { debounce } from "../../utils/debounce";

let moment = require("moment");

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: "",
      currentFilterId: 0,
      isOpenSearchFilterBox: false,
      isSelectingPeriod: false,
      loading: false,
      searchValue: "",
      currentFlag: null,
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.getChatList = this.getChatList.bind(this);
  }

  componentDidMount() {
    this.mounted = true;

    this.setState({
      currentFilterId: this.props.selectedFilterId,
    });

    if (
      this.props.dynamicMessageFilter === true &&
      this.props.contextFilter.length > 0
    ) {
      let contextFilter = this.props.contextFilter.find(
        (elem) =>
          elem.description === window.Social.getChatConfig().hashElementPrefix
      );

      if (contextFilter) {
        contextFilter = contextFilter && contextFilter.content;

        this.setState({
          search: `#${this.props.contextFilter}`,
          isOpenSearchFilterBox: false,
        });
      }
    }

    window.mention = this.mention;

    this.props.getSearchBarGetChatsFunction &&
      this.props.getSearchBarGetChatsFunction(this.getChatList);
  }

  componentDidUpdate(prevProps) {
    if (this.mounted) {
      const chatConfig = window.Social.getChatConfig();

      if (
        (prevProps.dynamicMessageFilter === false &&
          this.props.dynamicMessageFilter === true) ||
        (this.props.dynamicMessageFilter &&
          prevProps.contextFilter !== this.props.contextFilter)
      ) {
        const hashElementPrefix =
          window.Social.getChatConfig().hashElementPrefix;

        let contextFilter = this.props.contextFilter.find((elem) => {
          return elem.description === hashElementPrefix;
        });

        if (contextFilter) {
          contextFilter = contextFilter && contextFilter.content;
          let newSearch = chatConfig.hashElementInQuotes
            ? `#"${contextFilter}"`
            : `#${contextFilter}`;

          this.setState(
            {
              search: newSearch,
              isOpenSearchFilterBox: false,
            },
            this.debounceChange(newSearch)
          );

          this.mention.clear();
          this.mention.insertBlock(
            `<span contenteditable="false" class="mention-user" style="color: #1976D2">${newSearch}</span>`
          );
        } else {
          this.setState(
            {
              search: "",
              isOpenSearchFilterBox: false,
            },
            this.debounceChange("")
          );

          this.mention.clear();
        }
      }

      if (this.props.canResetFilters) {
        this.resetFilters();
        this.props.filtersReseted();
      }
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    this.debounceChange.clear();
    this.debounceUserSearchChange.clear();
    document.removeEventListener("click", this.handleClickOutside);
  }

  openSearchFilterBox(e) {
    e.stopPropagation();
    this.setState(
      {
        isOpenSearchFilterBox: true,
      },
      () => document.addEventListener("click", this.handleClickOutside)
    );
  }

  handleClickOutside(event) {
    if (
      this.state.isOpenSearchFilterBox &&
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target)
    ) {
      event.stopPropagation();
      this.setState({
        isOpenSearchFilterBox: false,
      });
      document.removeEventListener("click", this.handleClickOutside);
    }
  }

  setCurrentFilterOption(id) {
    this.setState(
      {
        currentFilterId: id,
      },
      this.props.setFilter(id)
    );
  }

  isOptionActive(id) {
    return this.state.currentFilterId === id ? "active" : "";
  }

  onInputChange(valueHtml, valueText) {
    this.setState({
      search: valueText,
    });

    this.debounceChange(valueText);
  }

  getChatList() {
    this.debounceChange(this.state.search);
  }

  debounceChange = debounce((value = "") => {
    let params = {};
    const chatConfig = window.Social.getChatConfig();

    let stateString = value;

    let contexts = chatConfig.hashElementInQuotes
      ? stateString.match(/#('|"|`)+(.*)+('|"|`)/g)
      : stateString.match(/#(\d+)/g);

    if (contexts) {
      params.element = contexts.map((elem) =>
        chatConfig.hashElementInQuotes
          ? elem.substr(0, elem.length - 1).substr(2)
          : elem.substr(1)
      );
      for (let i = 0; i < contexts.length; i++) {
        stateString = stateString.replace(contexts[i], "").trim();
      }
    }

    let mentions = stateString.match(/\B(@[a-z0-9._-]+)/g);

    if (mentions && mentions.length > 0) {
      params.recipient = mentions.map((elem) => elem.replace("@", ""));

      for (
        let i = 0, mentionsLength = mentions.length;
        i < mentionsLength;
        i++
      ) {
        stateString = stateString.replace(mentions[i], "").trim();
      }
    }

    let startDate = stateString.match(
      /de:[0-9][0-9]-[0-9][0-9]-[0-9][0-9][0-9][0-9]/
    );

    if (startDate) {
      let startStr = startDate[0].substr(3);
      startStr = startStr.split("-");
      startStr = new Date(startStr.pop(), startStr.pop() - 1, startStr.pop());
      params.sendMessageStartDate = moment(startStr)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      stateString = stateString.replace(startDate[0], "");
    }

    let endDate = stateString.match(
      /at(e|é):[0-9][0-9]-[0-9][0-9]-[0-9][0-9][0-9][0-9]/
    );

    if (endDate) {
      let endStr = endDate[0].substr(4);
      endStr = endStr.split("-");
      endStr = new Date(endStr.pop(), endStr.pop() - 1, endStr.pop());
      params.sendMessageEndDate = moment(endStr)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      stateString = stateString.replace(endDate[0], "");
    }

    if (chatConfig.allowFlags && this.state.currentFlag) {
      params.flags = [this.state.currentFlag];
    }

    stateString = stateString.trim();

    if (stateString !== "") {
      params.description = stateString;
    }

    this.props.getChatList && this.props.getChatList(params);
  }, 250);

  addTextToEndOfInput(value) {
    if (this.search && this.search.length) {
      this.mention.insertTextAtEnd(`${value}`);
    } else {
      this.mention.insertTextAtEnd(`&nbsp;${value}`);
    }
    this.setState({
      isOpenSearchFilterBox: false,
    });
  }

  getPlaceholder() {
    const filter = window.Social.getFilterConfig()[this.state.currentFilterId];

    return this.props.intl.formatMessage(
      { id: "filter.searchIn" },
      { name: this.props.intl.formatMessage({ id: filter.sufixForLabels }) }
    );
  }

  resetFilters() {
    this.mention.clear();
    this.setState(
      {
        search: "",
        isOpenSearchFilterBox: false,
        currentFlag: null,
      },
      this.setCurrentFilterOption(0)
    );
  }

  filterByPeriod() {
    this.setState(
      {
        isSelectingPeriod: true,
        isOpenSearchFilterBox: false,
      },
      document.removeEventListener("click", this.handleClickOutside)
    );
  }

  onPeriodSelected(start, end) {
    const newSearch = `de:${start.format("DD-MM-YYYY")} até:${end.format(
      "DD-MM-YYYY"
    )}`;

    this.mention.insertBlock(
      `<span contenteditable="false" style="color: #1976D2">${newSearch}</span>`
    );

    this.setState(
      {
        isSelectingPeriod: false,
      },
      this.debounceChange(newSearch)
    );
  }

  onCalendarClickAway() {
    this.setState({
      isSelectingPeriod: false,
    });
  }

  fetchUsers(params = {}, callback) {
    UserService.getUsers(params).then(callback);
  }

  getUserAvatar(user) {
    return DefaultUserImage;
  }

  debounceUserSearchChange = debounce((searchValue, callback) => {
    if (searchValue.length > 0) {
      this.setState({
        loading: true,
      });

      this.fetchUsers({ name: searchValue }, (res) => {
        const suggestions =
          res &&
          res.data &&
          res.data.content.map((suggestion) => {
            return {
              key: suggestion.username,
              value: suggestion.name,
            };
          });

        this.setState({
          searchValue,
          loading: false,
        });

        return callback(suggestions);
      });
    }
  }, 500);

  getNotFoundContentString() {
    const { formatMessage } = this.props.intl;

    return this.state.searchValue && this.state.searchValue.length > 0
      ? formatMessage({ id: "chat.userNotFound" })
      : formatMessage({ id: "chat.typeUserName" });
  }

  getFilters() {
    const { formatMessage } = this.props.intl;
    const activeIcon = (
      <Icon className="search-option-active" component={CheckSvg} />
    );
    const filters = Object.values(window.Social.getFilterConfig());

    return filters.map((elem) => (
      <span
        className={"search-filter-option " + this.isOptionActive(elem.index)}
        onClick={() => this.setCurrentFilterOption(elem.index)}
        key={elem.index}
      >
        {formatMessage({ id: elem.description })}
        {this.isOptionActive(elem.index) ? activeIcon : false}
      </span>
    ));
  }

  setCurrentFlag = (flagId) => {
    const current = this.state.currentFlag === flagId ? null : flagId;

    this.setState(
      {
        currentFlag: current,
      },
      () => this.props.setCurrentFlag(current)
    );
  };

  isFlagActive = (flagId) => {
    return this.state.currentFlag === flagId;
  };

  getFlagFilters() {
    const chatConfig = window.Social.getChatConfig();
    const flags = this.props.flags;
    const activeIcon = (
      <Icon className="search-option-active" component={CheckSvg} />
    );
    const { formatMessage } = this.props.intl;

    let flagFilters = [];
    if (chatConfig.allowFlags && flags && flags.length > 0) {
      flagFilters.push(
        <span key="flag-label" className="search-label">
          {formatMessage({ id: "filter.filterByFlag" })}
        </span>
      );
      let flagOptions = flags.map((elem) => (
        <span
          className={`search-filter-option ${
            this.isFlagActive(elem.id) ? "active" : ""
          }`}
          onClick={() => this.setCurrentFlag(elem.id)}
          key={elem.id}
        >
          <span
            className="flag-color"
            style={{ backgroundColor: elem.color }}
          />
          {elem.flagName}
          {this.isFlagActive(elem.id) ? activeIcon : false}
        </span>
      ));

      flagFilters = flagFilters.concat(flagOptions);

      flagFilters.push(
        <span className="separator" key="flag-separator"></span>
      );
    }

    return flagFilters;
  }

  getMentionsOptions() {
    return {
      collection: [
        {
          trigger: "@",
          lookup: (item) => `${item.key} ${item.value}`,
          fillAttr: "key",
          requireLeadingSpace: true,
          allowSpaces: false,

          values: (text, callback) => {
            this.debounceUserSearchChange(text, callback);
          },

          selectTemplate: (item) => {
            return `<span contenteditable="false" class="mention-user" style="color: #1976D2">@${item.original.key}</span>`;
          },

          menuItemTemplate: (item) => {
            const avatarSrc = this.getUserAvatar(item.original);
            return `<div class="list-item">
                      <div class="image"><img src="${avatarSrc}"/></div>
                      <div class="content">
                        <div class="title">@${item.original.key}</div><div class="description">${item.original.value}</div>
                      </div>
                    </div>`;
          },
        },
      ],
    };
  }

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <div className={`search-bar ${this.props.collapsed ? "collapsed" : ""}`}>
        <Icon className="search-icon" component={SearchSvg} />

        <Mention
          ref={(node) => (this.mention = node)}
          placeholder={this.getPlaceholder()}
          notFoundContent={this.getNotFoundContentString()}
          onInputChange={this.onInputChange.bind(this)}
          options={this.getMentionsOptions()}
        />

        <div
          className="dropdown-container"
          ref={(node) => (this.dropdownContainerRef = node)}
        />

        <Tooltip
          title={formatMessage({ id: "tooltip.searchFilters" })}
          overlayClassName="social-tooltip"
        >
          <Icon
            className={`action-button ${
              this.state.isOpenSearchFilterBox ? "active" : ""
            }`}
            component={ListFilterSvg}
            onClick={this.openSearchFilterBox.bind(this)}
          />
        </Tooltip>

        {this.state.isSelectingPeriod && (
          <CalendarPicker
            onPeriodSelected={this.onPeriodSelected.bind(this)}
            onCalendarClickAway={this.onCalendarClickAway.bind(this)}
          />
        )}

        {this.state.isOpenSearchFilterBox && (
          <div
            className="search-filter-options"
            ref={(node) => (this.wrapperRef = node)}
          >
            <span className="search-label">
              {formatMessage({ id: "general.toFilter" })}
            </span>

            {this.getFilters()}

            <span className="separator"></span>

            {this.getFlagFilters()}

            <span
              className={"search-filter-option"}
              onClick={this.filterByPeriod.bind(this)}
            >
              {formatMessage({ id: "filter.filterByPeriod" })}
            </span>

            <span
              className={"search-filter-option"}
              onClick={() => this.addTextToEndOfInput("#")}
            >
              {formatMessage({ id: "filter.filterByProcess" })}
            </span>

            <span
              className={"search-filter-option"}
              onClick={() => this.addTextToEndOfInput("@")}
            >
              {formatMessage({ id: "filter.filterByRecipient" })}
            </span>

            <span className="separator"></span>

            <span
              className={"search-filter-option"}
              onClick={this.resetFilters.bind(this)}
            >
              {formatMessage({ id: "filter.clearFilters" })}
            </span>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ Api, GeneralSettings }) => {
  return {
    dynamicMessageFilter: GeneralSettings.dynamicMessageFilter,
    contextFilter: Api.contextFilter,
  };
};

export default connect(mapStateToProps)(injectIntl(SearchBar));
